import { Directive, HostListener, Input, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MenuService } from '@services/menu.service';
import { Subscription } from 'rxjs';
import { distinctUntilChanged } from 'rxjs/operators';
import { DialogComponent } from './dialog.component';

const dialogMargin = 70;
const headerHeight = 50;

@Directive({
  // tslint:disable-next-line: directive-selector
  selector: '[openLaunchMainDialog]'
})
export class OpenMainDialogDirective implements OnDestroy {
  private readonly subscriptions: Subscription[] = [];
  public maximized = false;
  public halfSized = false;
  private dialogRef: MatDialogRef<DialogComponent>;

  @Input() menuOption: number;

  constructor(public dialog: MatDialog, private readonly menu: MenuService) {
    if (!this.menu) {
      return;
    }

    const maximizedSubscription = this.menu.maximized$.pipe(distinctUntilChanged()).subscribe(value => {
      if (this.maximized !== value) {
        this.maximized = value;
        this.updateDialogSize();
      }
    });
    const halfSizedSubscription = this.menu.halfSized$.pipe(distinctUntilChanged()).subscribe(value => {
      if (this.halfSized !== value) {
        this.halfSized = value;
        this.updateDialogSize();
      }
    });
    this.subscriptions.push(maximizedSubscription, halfSizedSubscription);
  }

  @HostListener('click') onClick() {
    this.openDialog();
  }

  public async openDialog() {
    this.menu.isOpenDialog = true;
    const dialogOptions = {
      height: 'calc(100% - 140px)',
      width: 'calc(100% - 140px)',
      position: { bottom: '' },
      maxWidth: '100vw',
      panelClass: ['ui-dialog-content'],
      disableClose: true,
      closeOnNavigation: false
    };

    this.dialogRef = this.dialog.open(DialogComponent, dialogOptions);
    this.updateDialogSize();

    const keyDownEventsSubscription = this.dialogRef.keydownEvents().subscribe(e => {
      // Ctrl + Alt + Up maximizes / restores the dialog
      if (e.key === 'ArrowUp' && e.ctrlKey && e.altKey) {
        this.menu.toggleMaximized();
      }

      // Ctrl + Alt + Right horizontally maximizes / restores the dialog
      if (e.key === 'ArrowRight' && e.ctrlKey && e.altKey) {
        this.menu.toggleHalfSized();
      }
    });
    this.subscriptions.push(keyDownEventsSubscription);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subs => subs.unsubscribe());
  }

  private updateDialogSize() {
    if (this.dialogRef) {
      try {
        if (this.maximized) {
          if (this.halfSized) {
            this.dialogRef.updatePosition({ bottom: `0px !important`, right: `30px !important` });
            this.dialogRef.updateSize(`calc(50% - ${dialogMargin}px)`, `calc(100% - ${headerHeight}px)`);
          } else {
            this.dialogRef.updatePosition({ bottom: `0px !important`, right: `` });
            this.dialogRef.updateSize(`100%`, `calc(100% - ${headerHeight}px)`);
          }
        } else {
          if (this.halfSized) {
            this.dialogRef.updatePosition({ bottom: ``, right: `${dialogMargin}px !important` });
            this.dialogRef.updateSize(`calc(50% - ${dialogMargin}px)`, `calc(100% - ${dialogMargin * 2}px)`);
          } else {
            this.dialogRef.updatePosition({ bottom: ``, right: `` });
            this.dialogRef.updateSize(`calc(100% - ${dialogMargin * 2}px)`, `calc(100% - ${dialogMargin * 2}px)`);
          }
        }
      } catch (error) {
      } finally {
        this.menu.emitResize();
      }
    }
  }
}
